@if (resource) {
  <div class="op-subproject-board-header">
    <h2 class="editable-toolbar-title--fixed">
      <small [textContent]="text.project"></small>
      <br/>
      <a [href]="pathHelper.projectPath(idFromLink(resource.href))"
        [textContent]="resource.name"
        target="_blank">
      </a>
    </h2>
  </div>
}
